<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* Chrome、Safari */
body::-webkit-scrollbar {
  display: none;
}
/* Firefox */
html, body {
  scrollbar-width: none;
}
/* IE、Edge */
html, body {
  -ms-overflow-style: none;
}

</style>



// WEBPACK FOOTER //
// src/App.vue